/**
 * If a Button is inside a menu override it to provide a proper menu
 */
import { createElement as rc } from 'react';
import { MenuItem as _MenuItem, Text, ThemeComponentSwitcher } from 'lib_ui-primitives';
import useEventSink from '../../hooks/useEventSink';
import Gl2025MenuItem from './MenuItem.gl2025';

function MenuItem(props) {
    const {
        hNode: { forAction, title, disabled, namespace, relation, type, subtype },
        actionPayload = {},
        ...otherProps
    } = props;
    const [, publish] = useEventSink();
    function onClick() {
        // use || operator here instead of ?? because subtype can be an empty string (
        // generated by blockly)
        publish(actionPayload, { verb: forAction, namespace, relation, type: subtype || type });
    }
    return rc(_MenuItem, { onClick, disabled, ...otherProps }, rc(Text, null, title));
}

let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: Gl2025MenuItem
    },
    { component: MenuItem }
]);
export default SwitchedComponent;
